export default __webpack_public_path__ + "static/media/cw-6h.9d115b4b.png";